// tslint:disable

import { get } from 'lodash';
import { development } from './development';
import { production } from './production';

export class Environment {
    private static env: string | any = process.env.NODE_ENV;

    private static source = {
        production: production,
        development: development
    };

    public static getEnv() {
        return Environment.env;
    }

    public static get(path: string) {
        return get(Environment.source[Environment.env], path);
    }
}



// WEBPACK FOOTER //
// ./src/environment/environment.ts